import React from 'react';
import { Box, Typography, Paper, Grid2, Tooltip } from '@mui/material';
import { motion } from 'framer-motion';

const BussinessDetailsCard = ({ vendor }: any) => (
	<motion.div
		initial={{ opacity: 0, y: 20 }}
		animate={{ opacity: 1, y: 0 }}
		transition={{ duration: 0.5 }}
	>
		<Paper sx={{ borderRadius: '10px', boxShadow: '0px 4px 4px rgba(0,0,0,0.1)' }}>
			{/* Header */}
			<Box
				sx={{
					height: 50,
					bgcolor: 'primary.main',
					display: 'flex',
					alignItems: 'center',
					pl: 3,
					borderTopLeftRadius: '12px',
					borderTopRightRadius: '12px',
				}}
			>
				<Typography
					color="white"
					fontWeight={600}
					fontFamily="Poppins"
					sx={{ fontSize: { xs: 14, sm: 18 } }}
				>
					Bank Details
				</Typography>
			</Box>

			{/* Content */}
			<Box sx={{ p: 3 }}>
				{/* Row 1 */}
				<Grid2 container spacing={4}>
					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							Account Holder
						</Typography>
						<Typography
							sx={{ fontSize: { xs: '14px', sm: '18px' } }}
							variant="subtitle1"
							fontWeight={500}
						>
							{vendor.companyName}
						</Typography>
					</Grid2>

					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							Account Number
						</Typography>
						<Typography
							sx={{ fontSize: { xs: '14px', sm: '18px' } }}
							variant="subtitle1"
							fontWeight={500}
						>
							{vendor.ownerName}
						</Typography>
					</Grid2>

					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							Account Type
						</Typography>

						<Tooltip title={vendor.email}>
							<Typography
								sx={{
									fontSize: { xs: '14px', sm: '18px' },
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									maxWidth: 200, // adjust width as per design
									cursor: 'pointer',
								}}
								variant="subtitle1"
								fontWeight={500}
							>
								{vendor.email}
							</Typography>
						</Tooltip>
					</Grid2>

					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							Bank Name
						</Typography>
						<Typography
							sx={{ fontSize: { xs: '14px', sm: '18px' } }}
							variant="subtitle1"
							fontWeight={500}
						>
							{vendor.mobile}
						</Typography>
					</Grid2>
				</Grid2>

				{/* Row 2 */}
				<Grid2 container spacing={4}>
					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							Branch
						</Typography>
						<Tooltip
							title={
								`${vendor?.companyAddress?.address}, ${vendor?.companyAddress?.city},{' '}
														${vendor?.companyAddress?.state}, ${vendor?.companyAddress?.country}` || ''
							}
							arrow
						>
							<Typography
								sx={{
									fontSize: { xs: '14px', sm: '18px' },
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									maxWidth: 200, // adjust width as per design
									cursor: 'pointer',
								}}
								variant="subtitle1"
								fontWeight={500}
							>
								{vendor.companyAddress?.address}, {vendor.companyAddress?.city},{' '}
								{vendor.companyAddress?.state}, {vendor.companyAddress?.country}
							</Typography>
						</Tooltip>
					</Grid2>

					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							IFSC Code
						</Typography>
						<Typography
							sx={{ fontSize: { xs: '14px', sm: '18px' } }}
							variant="subtitle1"
							fontWeight={500}
						>
							{vendor.companyType}
						</Typography>
					</Grid2>

					<Grid2 size={{ xs: 12, sm: 3 }}>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ fontSize: { xs: 12, sm: 14 } }}
						>
							Submitted Date
						</Typography>
						<Typography
							sx={{ fontSize: { xs: '14px', sm: '18px' } }}
							variant="subtitle1"
							fontWeight={500}
						>
							{new Date(vendor.createdAt).toLocaleDateString()}
						</Typography>
					</Grid2>
				</Grid2>
			</Box>
		</Paper>
	</motion.div>
);

export default BussinessDetailsCard;
